// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import requests from './utils/request'
import global from '@/utils/global_val' //全局变量
import utils from '@/utils/utils' //全局变量
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import {
  Lazyload
} from 'vant';
import 'swiper/swiper-bundle.css';
import Vant from 'vant';
import 'vant/lib/index.css';
// 点击图片放大展示
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
// 公共底图组件
import comBg from '@/components/com-bg.vue'
Vue.component("comBg", comBg);
Vue.config.productionTip = false
Vue.use(Lazyload);
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)
Vue.prototype.$ajax = requests
Vue.prototype.global = global
Vue.use(global);
Vue.prototype.utils = utils;
Vue.use(utils);
Vue.use(Vant);
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);
Vue.use(preview, options)
// 配置项感觉也可以放在具体的组件中
var options = {
  fullscreenEl: false, //关闭全屏按钮
  tapToClose: true,
}

Vue.use(VueDirectiveImagePreviewer)
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      localStorage.setItem('ismobile', flag ? 1 : 0);
      let goUrl = flag ? 1 : 0;
      return goUrl;
    }
  },

  watch: {
    $route(value) {
      var path = value.path.indexOf("/m");
      let goUrl = this.isMobile();
      if (goUrl === 1) {
        //移动端地址
        if (path == 0) {
          setRem(value.path);
        } else {
          setRem('/m');
        }
      } else {
        setRemPC();

      }
    }
  },
  created() {
    // setRem();

  },
})
// rem换算
// 手机端
function setRem(jump) {
  var whdef = 100 / 750; // 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
  if (jump == '/m/mTheMainVenueDetails' || jump == '/m/mBranchVenueDetails' || jump == '/m/fbec-venue-sign') {
    return;
  } else {
    router.push({
      path: jump
    })
  }

  // console.log(this.roujump)

}
// PC端
function setRemPC() {
  var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}



// WEBPACK FOOTER //
// ./src/main.js